import React from 'react';
import "./style.css"
import { connect } from 'react-redux';
import { useMediaQuery, useTheme } from '@mui/material';

const ActiveCard = (props) => {
    const { type } = props
    const { account } = props.User;
    const theme = useTheme()
    const smallView = useMediaQuery(theme.breakpoints.down('sm'))
    const api = 'https://api.indimoves.com/'

    return (
        <div id="active-card-wrap">
            <div className='logo-wrapper-main'>
                <div className='logo-wrapper'>
                    <img src={api + account?.user?.logo} />
                </div>
            </div>

            <div className={`text-wrapper ${type === 'subscription' ? 'fullwidth' : ''}`}>
                <p>{account?.user?.name} has partnered with Indi to keep you moving. {type === 'billing' && smallView ? (<><br /> <br /> </>) : null}</p>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps)(ActiveCard);